import React, { Component } from "react";

import { Link, Redirect } from "react-router-dom";

import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import Logo from "../assets/images/logo.png";
import Menu from "../assets/svg/menu-light.svg";

import MenuFunc from "./Menu";
import Editgoal from "./Editgoal";
import Addprogress from "./Addprogress";

import { Helmet } from "react-helmet";

class Radar extends Component {
  state = {
    menuToggled: false,
    editGoal: false,
    addProgress: false,
  };

  componentDidMount() {}

  setmenuoff = (wot) => {
    this.setState({ menuToggled: wot });
  };

  seteditgoal = (wot) => {
    this.setState({ editGoal: wot });
  };

  setaddprogress = (wot) => {
    this.setState({ addProgress: wot });
  };

  parsedate = (seconds) => {
    let d = new Date(seconds * 1000);
    let options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return d.toLocaleDateString("en-US", options);
  };

  render() {
    const { profile, progress, auth } = this.props;
    if (JSON.parse(localStorage.getItem('isPremium')) === true) {
        profile.isPremium = true;
    }
    if (!auth.uid) return <Redirect to="/" />;
    if (!profile.isPremium) return <Redirect to="/upgrade" />;

    let d = profile.weightDate
      ? new Date(profile.weightDate.seconds * 1000)
      : new Date();
    let options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    let dateobj = d.toLocaleDateString("en-US", options);
    return (
      <div>
        <Helmet>
          <title>Weight Radar</title>
          <meta
            name="description"
            content="BoxFit is the ultimate home workout web-app
    with over 390 video exercises, 10 different workout categories and premium
    features such as Workout History & Weight Radar."
          />

          <meta property="og:url" content="https://www.boxfit-fitness.com/radar" />
          <meta property="og:title" content="BoxFit" />
          <meta
            property="og:description"
            content="BoxFit is the ultimate home workout web-app
    with over 390 video exercises, 10 different workout categories and premium
    features such as Workout History & Weight Radar."
          />
          <meta property="og:site_name" content="BoxFit" />
          <meta
            property="og:image"
            content="https://www.boxfit-fitness.com/images/sharer.png"
          />
          <meta property="og:type" content="profile" />
          <meta property="og:locale" content="en_US" />
        </Helmet>
        <div style={{ position: "relative" }}>
          <MenuFunc display={this.state.menuToggled} off={this.setmenuoff} />
          {this.state.editGoal ? <Editgoal off={this.seteditgoal} /> : null}
          {this.state.addProgress ? (
            <Addprogress off={this.setaddprogress} />
          ) : null}

          <div
            style={{
              zIndex: 999,
              position: "absolute",
              top: "15px",
              left: "20px",
            }}
          >
            <Link
              to={{
                pathname: "/",
                query: {
                  fromMenu: true,
                },
              }}
            >
              <img src={Logo} alt="logo" style={{ maxHeight: "45px" }}></img>
            </Link>
          </div>

          <div
            style={{
              position: "absolute",
              top: "25px",
              right: "22px",
              zIndex: 999,
            }}
            onClick={() => {
              this.setmenuoff(true);
            }}
          >
            <img src={Menu} alt="logo" style={{ maxHeight: "25px" }}></img>
          </div>
        </div>

        <div
          className="Screen"
          style={
            {
              /*height: "800px",
            width: "450px",
            borderRadius: "20px",
            boxShadow: "2px 2px 120px rgba(255, 255, 255, 0.15)",
            backgroundColor: "#000",*/
            }
          }
        >
          <div>
            <div style={{ height: "60px" }}></div>
            <div style={{ padding: "0px 20px 20px 20px" }}>
              <h2
                style={{
                  fontSize: "28px",
                  color: "#69C9D0",
                  borderRadius: "2px",
                }}
              >
                Weight Radar
              </h2>

              {profile.weightDate && profile.weightGoal ? (
                <p
                  style={{
                    fontSize: "18px",
                    textAlign: "left",
                  }}
                >
                  Your weight goal is set for{" "}
                  <strong>{profile.weightGoal}lbs</strong> by{" "}
                  <strong>{dateobj}.</strong>
                </p>
              ) : (
                <p
                  style={{
                    fontSize: "18px",
                    textAlign: "left",
                  }}
                >
                  You don't have a goal set. Click the button below to edit or
                  add one.
                </p>
              )}

              <p>
                <button
                  style={{
                    background: "#333",
                    color: "white",
                    border: 0,
                    borderRadius: "3px",
                    padding: "8px",
                    float: "left",
                    fontSize: "16px",
                  }}
                  onClick={() => {
                    this.seteditgoal(true);
                  }}
                >
                  {profile.weightGoal ? "Edit Goal" : "Add Goal"}
                </button>
                <button
                  style={{
                    background: "#333",
                    color: "white",
                    border: 0,
                    borderRadius: "3px",
                    padding: "8px",
                    float: "right",
                    fontSize: "16px",
                  }}
                  onClick={() => {
                    this.setaddprogress(true);
                  }}
                >
                  Add Progress
                </button>
              </p>
              <div style={{ height: "60px" }}></div>

              <div>
                {progress && progress.length > 0 ? (
                  <table className="table">
                    <thead>
                      <tr className="tableh">
                        <th>Date</th>
                        <th>Weight</th>
                      </tr>
                    </thead>
                    <tbody>
                      {progress ? (
                        progress.map((obj, i, arr) => {
                          return (
                            <tr key={i}>
                              <td>{this.parsedate(obj.added.seconds)}</td>
                              <td>{obj.weight}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr></tr>
                      )}
                    </tbody>
                  </table>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const exelogs = state.firestore.ordered["weight-logs"];
  const exelog = exelogs ? exelogs : [];

  if (JSON.parse(localStorage.getItem('isPremium')) === true) {
    state.firebase.profile.isPremium = true;
  }
  console.log(exelog);

  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
    progress: exelog,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => [
    {
      collection: "weight-logs",
      where: [["user", "==", props.auth.uid || ""]],
      orderBy: [["added", "desc"]],
    },
  ])
)(Radar);
